












































import { TbMember } from '@/http';
import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
@Component({
    components: {
    },
})
export default class exchangeReminder extends Vue {
    public $refs: {
    };

    @Prop({
        default:false
    })
    show:Boolean;

    @Prop({
        type:Object,
        default:()=>{
            return{

            }
        }
    })
    form:any;

    created() {
    }   
    
    mounted() {
       
    }

    closeFun(){
        this.$emit('closeFun');
    }
    confirmFun(){
        this.$emit('confirmFun');
    }

   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/cashier/components/exchangeReminder.vue